const axios = require('axios');

module.exports = {

    getLocationList() {
        return axios.get(`support/location`)
    },
    getChildLocationList(lidx) {
        return axios.get(`support/location/child/${lidx}`)
    },
    getSearchList(keyword, lidx, coronaType, childbirth_type, child_birth, income_type, income, require_card, multi_cultural, disabled, second_tier, one_parent, basic_income, page_offset) {
        return axios.get(`support/search/${keyword}/${lidx}/${coronaType}/${childbirth_type}/${child_birth}/${income_type}/${income}/${require_card}/${multi_cultural}/${disabled}/${second_tier}/${one_parent}/${basic_income}/${page_offset}`)
    },
    getGovermentList(coronaType, childbirth_type, child_birth, income_type, income, require_card, multi_cultural, disabled, second_tier, one_parent, basic_income, page_offset) {
        return axios.get(`support/goverment/${coronaType}/${childbirth_type}/${child_birth}/${income_type}/${income}/${require_card}/${multi_cultural}/${disabled}/${second_tier}/${one_parent}/${basic_income}/${page_offset}`)
    },
    getList(keyword, lidx, pageOffset) {
        return axios.get(`support/list/${keyword}/${lidx}/${pageOffset}`)
    },
    getInfo(sidx) {
        return axios.get(`support/info/${sidx}`)
    }
};